import axios from '../config/axios';
import config from '../config/index';
import { notification } from 'antd';
import {getResponseHandler,header} from './commonService'

const users = {
    getUserList : async (data = {}) => {
        try{
            let rowData;
            if(data?.paramID>0){
                 rowData = await axios.get('/users/'+data?.paramID)
            }else{
                 rowData = await axios.get('/users',{params:data} )
            }
            
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    addUser : async (data={}) =>{
        try{
            const rowData = await axios.post('/users',data)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    updateUser : async (id, data={}) =>{
        try{
            const rowData = await axios.patch('/users/'+id,data)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    } ,
    deleteUser: async (id) => {
        try{
            const rowData = await axios.delete('/users/'+id)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },

    getDashboardList : async (data = {}) => {
        try{
            let rowData;
            rowData = await axios.get('/users/dashboard',data)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 

    changeStatus : async (data = {}) => {
        try{
            const rowData = await axios.post('/users/statusChange',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    }, 

    updatePassword : async (data = {}) => {
        try{
            const rowData = await axios.post('/users/updatePassword',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },
    getCity : async (data = {}) => {
        try{
            const rowData = await axios.post('/users/getCity',data)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },
    getState : async (data = {}) => {
        try{
            const rowData = await axios.post('/users/getState',data)
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },
    upload(file, folder, onUploadProgress) {
        let formData = new FormData();
    
        formData.append("file", file);
    
        return axios.post(config.url+"file/upload?folder="+folder+"&mediaFor="+folder, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress,
        });
      },
    
      getFiles(filename) {
        return axios.post("/file/download",filename);
      },
      /**********88Satish 25 oct */
       getBankList : async (data = {}) => {
            try{
                console.log('satish',data);                
                const rowData = await axios.get('/users/getBankList',header(data))
                const response = await rowData;
                return getResponseHandler(response); 
            }catch (error){
                console.error(error);
                notification.error({ message: error.message, placement:'bottomRight' });
            }
        }, 
        updateBankDetail : async (data={}) =>{
           
            try{
                const rowData = await axios.post('/users/updateBankDetail',data)
                const response = await rowData;
                return getResponseHandler(response);               
            }catch (error){
                console.error(error);
                notification.error({ message: error.message, placement:'bottomRight' });
            }
        },

        loginWithMobile : async (data={}) =>{
            try{
                const rowData = await axios.post('/users/sendSmsApi',data)
                const response = await rowData;
                return getResponseHandler(response);               
            }catch (error){
                console.error(error);
                notification.error({ message: error.message, placement:'bottomRight' });
            }
        }, 
        forgotPasswordCodeSend : async (data={}) =>{
            try{
                const rowData = await axios.post('/authentication/forgotPasswordCodeSend',data)
                const response = await rowData;
                return getResponseHandler(response);               
            }catch (error){
                console.error(error);
                notification.error({ message: error.message, placement:'bottomRight' });
            }
        }, 
        forgotPasswordCodeVerify : async (data={}) =>{
            try{
                const rowData = await axios.post('/authentication/forgotPasswordCodeVerify',data)
                const response = await rowData;
                return getResponseHandler(response);               
            }catch (error){
                console.error(error);
                notification.error({ message: error.message, placement:'bottomRight' });
            }
        }, 
        signupVerification : async (data={}) =>{
            try{
                const rowData = await axios.post('/users/signupverification',data)
                const response = await rowData;
                return getResponseHandler(response);               
            }catch (error){
                console.error(error);
                notification.error({ message: error.message, placement:'bottomRight' });
            }
        }, 
      /************End */
                           
    
}


export default users